"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const currency_symbol_map_1 = __importDefault(require("currency-symbol-map"));
const utils_1 = require("./utils");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.amountSpanStyle);
const AmountSpan = (_a) => {
    var { initialValue, onBlur, className, onChange, style = {}, variant = 'body1', editable = true, currencyString = 'USD', showSign = false, negator = -1, id = 'amountSpan', underlineOnFocus = false, focusedOnMount = false, clearFieldOnClick = false, shouldStopProp = true, onFocus = () => { } } = _a, otherProps = __rest(_a, ["initialValue", "onBlur", "className", "onChange", "style", "variant", "editable", "currencyString", "showSign", "negator", "id", "underlineOnFocus", "focusedOnMount", "clearFieldOnClick", "shouldStopProp", "onFocus"]);
    const [amount, setAmount] = (0, react_1.useState)(initialValue);
    const [sign, setSign] = (0, react_1.useState)((0, utils_1.signFromValue)(initialValue));
    const spanRef = (0, react_1.useRef)(null);
    const [focused, setFocus] = (0, react_1.useState)(false);
    const [chop, setChop] = (0, react_1.useState)(false);
    const { classes, cx, theme } = useStyles();
    (0, react_1.useEffect)(() => {
        var _a;
        setAmount(initialValue);
        setSign((0, utils_1.signFromValue)(initialValue));
        if (spanRef.current) {
            (_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            spanRef.current.textContent = (0, utils_1.formatNumber)(initialValue);
        }
    }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        var _a;
        if (focusedOnMount && spanRef.current) {
            (_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [focusedOnMount]);
    const handleChange = (0, react_1.useCallback)(() => {
        var _a;
        if (onChange && spanRef.current) {
            onChange(Number((0, utils_1.chopValue)((0, utils_1.pruneString)((_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.innerText))));
        }
    }, [onChange]);
    (0, react_1.useEffect)(() => {
        const node = spanRef.current;
        if (node && onChange) {
            node.addEventListener('DOMSubtreeModified', handleChange);
        }
        return () => {
            if (node) {
                node.removeEventListener('DOMSubtreeModified', handleChange);
            }
        };
    }, [onChange, handleChange]);
    (0, react_1.useEffect)(() => {
        if (chop && spanRef.current) {
            const node = spanRef.current;
            const caretPosition = (0, utils_1.getCaretPosition)(node);
            node.textContent = (0, utils_1.chopValue)(node.innerText);
            (0, utils_1.setCaretPosition)(node, caretPosition);
            setChop(false);
        }
    }, [chop]);
    let update = true; // controls how to handle the blur (don't update on escape)
    const amtFocus = () => {
        var _a;
        onFocus();
        setFocus(true);
        if (spanRef.current) {
            spanRef.current.textContent = (0, utils_1.pruneString)((_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.innerText);
        }
        update = true;
    };
    const amtKeyDown = (e) => {
        var _a, _b, _c, _d;
        let selectedChars;
        const currentString = ((_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.innerText) || '';
        const keyNum = e.keyCode || e.which;
        switch (keyNum) {
            case 8: // backspace
                break;
            case 13: // enter
                (_b = spanRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                break;
            case 27: // escape
                update = false;
                (_c = spanRef.current) === null || _c === void 0 ? void 0 : _c.blur();
                break;
            case 65: // a
            case 67: // c
            case 86: // v
                if (!(e.metaKey || e.ctrlKey)) { // allow copy and paste and select
                    e.preventDefault();
                }
                break;
            case 110: // decimal
            case 190: // period
                if (currentString.length > 10) {
                    e.preventDefault();
                }
                if (currentString && currentString.indexOf('.') >= 0) {
                    selectedChars = window.getSelection && ((_d = window.getSelection()) === null || _d === void 0 ? void 0 : _d.getRangeAt(0).toString());
                    if (!selectedChars || selectedChars.indexOf('.') === -1) { // if period is not selected, prevent period entry
                        e.preventDefault();
                    }
                }
                break;
            default:
                if (e.key === '+' || e.key === '-') { // key is a sign
                    setSign(e.key);
                    e.preventDefault();
                }
                else if (keyNum === 32 || (keyNum >= 48 && keyNum <= 222)) {
                    if ('0123456789'.indexOf(e.key) === -1) {
                        e.preventDefault(); // invalid keys
                    }
                    else if (currentString.length > 10) {
                        e.preventDefault(); // valid digit but too long
                    }
                    else {
                        const caretPosition = (0, utils_1.getCaretPosition)(spanRef.current);
                        const periodIndex = currentString.indexOf('.');
                        if (periodIndex >= 0 && caretPosition > periodIndex && currentString.length > periodIndex + 2) {
                            if (caretPosition === currentString.length) {
                                e.preventDefault();
                            }
                            else { // truncate post-decimal submissions
                                setChop(true);
                            }
                        }
                    }
                }
                break;
        }
    };
    const amtBlur = () => {
        var _a, _b;
        setFocus(false);
        if (update && spanRef.current) {
            const signedValue = parseFloat(((_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.innerText) || '0').toFixed(2) * (0, utils_1.operatorFromSign)(sign, negator);
            // update amount if different
            if (Number(signedValue) !== Number(amount)) {
                setAmount(signedValue);
                if (onBlur) {
                    onBlur(signedValue);
                }
            }
            spanRef.current.textContent = (0, utils_1.formatNumber)((_b = spanRef.current) === null || _b === void 0 ? void 0 : _b.innerText);
        }
        else if (spanRef.current) { // reformat last valid amount
            spanRef.current.textContent = (0, utils_1.formatNumber)(amount);
        }
    };
    const amtPaste = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const clipboardData = e.clipboardData || window.clipboardData;
        let text = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData('Text'); // only keep textData
        text = text && (0, utils_1.pruneString)(text); // only insert valid text
        window.document.execCommand('insertText', false, text);
    };
    const handleClick = (e) => {
        var _a;
        if (shouldStopProp) {
            e.stopPropagation();
        }
        if (!focused && spanRef.current) {
            spanRef.current.focus();
        }
        if (clearFieldOnClick && ((_a = spanRef.current) === null || _a === void 0 ? void 0 : _a.textContent) === '0.00') {
            spanRef.current.textContent = '';
        }
    };
    return (<div role="presentation" onClick={editable ? handleClick : () => { }} className={cx((editable && (focused ? ((underlineOnFocus && classes.underlineFocused) || classes.focused) : classes.normal)) || classes.root, className)} style={Object.assign(Object.assign(Object.assign({}, theme.typography[variant]), { lineHeight: '100%' }), style)} id={`${id}-root`} sharedcomponentid={'AMOUNT_SPAN'} // eslint-disable-line react/no-unknown-property 
     onFocus={onFocus} {...otherProps}>
      <span style={{ paddingLeft: 5 }}>
        {`${(showSign || sign !== (0, utils_1.signFromValue)(negator)) ? sign : ''}${(0, currency_symbol_map_1.default)(currencyString || 'N/A')}`}
      </span>
      <span aria-label="amount" id={`${id}-span`} role="textbox" tabIndex={editable ? 0 : undefined} onKeyDown={amtKeyDown} onBlur={amtBlur} onFocus={amtFocus} ref={spanRef} contentEditable={editable} className={classes.editSpan} onPaste={amtPaste}/>
    </div>);
};
exports.default = AmountSpan;
